import { z } from 'zod';
import { UserRole } from './auth';

export const customPeriodRangeSchema = z
  .object({
    startDate: z.date({
      errorMap: () => ({
        message: 'A data de início é obrigatória e deve ter um valor váldo.',
      }),
    }),
    endDate: z.date({
      errorMap: () => ({
        message: 'A data de fim é obrigatória e deve ter um valor váldo.',
      }),
    }),
  })
  .superRefine((data, ctx) => {
    const MAX_INTERVAL_MS = 15778800000; // 6 meses
    if (data.endDate.getTime() - data.startDate.getTime() > MAX_INTERVAL_MS) {
      ctx.addIssue({
        code: 'custom',
        message: 'O intervalo máximo é de 6 meses.',
        path: ['endDate'],
      });
      return;
    }

    if (data.startDate.getTime() > data.endDate.getTime()) {
      ctx.addIssue({
        code: 'custom',
        message: 'A data de início deve ser menor que a data de fim.',
        path: ['endDate'],
      });
      return;
    }
  });
export type CustomPeriodRangeForm = z.infer<typeof customPeriodRangeSchema>;

export type DashboardFilters = {
  botConfigIds: number[];
  /**
   * The named range the producer picked, when they picked one - absent for a custom range.
   *
   * Carried so a screen can hand its selection to another screen and have the period label survive the
   * trip, not just the resolved dates.
   */
  periodRange?: string;
  startDate: Date;
  endDate: Date;
  previousPeriodStartDate: Date;
  previousPeriodEndDate: Date;
  clientTz: string;
  /**
   * O papel escolhido no filtro, quando há um.
   *
   * OPCIONAL desde a #360: "Tudo o que eu alcanço" é a ausência de papel, e é o modo em que o
   * escopo por produto responde sozinho — o único que serve a comunidade alcançada por grant, que
   * não tem papel de comissão nenhum.
   */
  userRole?: UserRole;
};
